import moment from "moment";
import { useEffect, useState } from "react";

import { ColoredButton } from "../../styledComponents/buttons";
import {
  SelectAllDateMemberSection,
  SummaryContainer,
  SummaryLabel,
  SummaryMultipleTableSection,
  SummarySectionContainer,
  SummaryText,
  SummaryTextSection,
} from "../../styledComponents/payroll";
import { currencySymbolMap } from "../../utils/currencies";
import {
  getHours,
  getHoursWithSeconds,
  globalDateFormat,
  toHHMMSS,
} from "../../utils/helper";

const SummarySingle = ({ summaryData, type, startDate, endDate, orgTimeZone }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (summaryData) {
      const key = Object.keys(summaryData)[0];
      setData({
        currency: key,
        payment: (summaryData[key].totalPay / 100).toFixed(2),
        duration: summaryData[key].duration || null,
      });
    }
  }, [summaryData]);
  return (
    <SummarySectionContainer
      columns={
        type && type === "fixed" ? "auto auto" : "auto auto auto"
      }
    >
      {data && (
        <>
          <SummaryTextSection>
            <SummaryText>
              {`${globalDateFormat(moment(startDate).tz(orgTimeZone).format("YYYY-MM-DD"), orgTimeZone)} - ${globalDateFormat(moment(endDate).tz(orgTimeZone).format("YYYY-MM-DD"), orgTimeZone)}`}
            </SummaryText>
            <SummaryLabel>Date Range</SummaryLabel>
          </SummaryTextSection>
          {type && type === "hourly" && (
            <SummaryTextSection>
              <SummaryText>
                {getHoursWithSeconds(toHHMMSS(data.duration))}
              </SummaryText>
              <SummaryLabel>Total Time Worked</SummaryLabel>
            </SummaryTextSection>
          )}
          <SummaryTextSection>
            <SummaryText total>
              {data.currency} ({currencySymbolMap[data.currency]}){" "}
              {data.payment}
            </SummaryText>
            <SummaryLabel>Total Payment</SummaryLabel>
          </SummaryTextSection>
        </>
      )}
    </SummarySectionContainer>
  );
};

const SummaryMultiple = ({ type, startDate, endDate, orgTimeZone, summaryData }) => {
  return (
    <SummaryTextSection multiple>
      <SummaryMultipleTableSection
        columns={
          type && type === "fixed" ? "2fr 1fr" : "2fr 1fr 1fr"
        }
      >
        <SummaryLabel>Date Range</SummaryLabel>
        {type && type === "hourly" && (
          <SummaryLabel>Total Time Worked</SummaryLabel>
        )}
        <SummaryLabel>Total Payment</SummaryLabel>
      </SummaryMultipleTableSection>
      {summaryData &&
        Object.keys(summaryData).map((key, index) => (
          <SummaryMultipleTableSection
            key={index}
            columns={
              type && type === "fixed" ? "2fr 1fr" : "2fr 1fr 1fr"
            }
          >
            <SummaryText multiple>
              {`${moment(startDate).tz(orgTimeZone).format("MMM DD, YYYY")} - ${moment(
                endDate,
              ).tz(orgTimeZone).format("MMM DD, YYYY")}`}
            </SummaryText>
            {type &&
              type === "hourly" &&
              summaryData[key] && (
                <SummaryText multiple>
                  {getHoursWithSeconds(
                    toHHMMSS(summaryData[key].duration),
                  )}
                </SummaryText>
              )}
            <SummaryText multiple total>
              {key}{" "}
              {summaryData[key] &&
                (summaryData[key].totalPay / 100).toFixed(2)}
            </SummaryText>
          </SummaryMultipleTableSection>
        ))}
    </SummaryTextSection>
  );
};

export const PayrollSummaryHistory = ({ paymentData, type, startDate, endDate, orgTimeZone }) => {
  const [summaryData, setSummaryData] = useState([]);

  useEffect(() => {
    if (paymentData && paymentData.length > 0) {
      const data = {};
      if (type === "hourly") {
        paymentData.map(payment => {
          if (data[payment.currency]) {
            data[payment.currency].totalPay += payment.total_pay;
            data[payment.currency].duration += payment.working_duration;
          } else {
            data[payment.currency] = {
              totalPay: payment.total_pay,
              duration: payment.working_duration,
            };
          }
        });
      } else if (type === "fixed") {
        paymentData.map(payment => {
          if (data[payment.currency]) {
            data[payment.currency].totalPay += payment.paid_amt;
          } else {
            data[payment.currency] = {
              totalPay: payment.paid_amt,
            };
          }
        });
      }

      setSummaryData({ ...data });
    } else if (paymentData && paymentData.length === 0) {
      setSummaryData({});
    }
  }, [paymentData]);

  return summaryData && Object.keys(summaryData).length !== 0 ? (
    <SummaryContainer
      width={type && type === "fixed" ? "500px" : "700px"}
    >
      {Object.keys(summaryData).length === 1 ? (
        <SummarySingle
          startDate={startDate}
          endDate={endDate}
          summaryData={summaryData}
          type={type}
          orgTimeZone={orgTimeZone}
        />
      ) : (
        <SummaryMultiple
          startDate={startDate}
          endDate={endDate}
          summaryData={summaryData}
          type={type}
          orgTimeZone={orgTimeZone}
        />
      )}
    </SummaryContainer>
  ) : null;
};

export const PayrollSummaryPayables = ({ paymentData, startDate, endDate, orgTimezone, toggleConfirmPaymentModal }) => {
  const [summaryData, setSummaryData] = useState(null);

  useEffect(() => {
    if (paymentData && paymentData.length > 0) {
      let duration = 0;
      let totalPay = 0;
      paymentData.map(payment => {
        duration += payment.total_duration;
        totalPay += payment.total_pay;
      });

      setSummaryData({
        currency: paymentData[0].currency,
        duration,
        totalPay,
      });
    } else if (paymentData && paymentData.length === 0) {
      setSummaryData(null);
    }
  }, [paymentData]);

  return summaryData ? (
    <SummaryContainer
      width="90%"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <SummarySectionContainer style={{ width: "80%" }}>
        <SummaryTextSection>
          <SummaryText>
            {`${globalDateFormat(moment(startDate).tz(orgTimezone).format("YYYY-MM-DD"),orgTimezone)} - ${globalDateFormat(
              moment(endDate).tz(orgTimezone).format("YYYY-MM-DD"),
              orgTimezone,
            )}`}
          </SummaryText>
          <SummaryLabel>Date Range</SummaryLabel>
        </SummaryTextSection>
        <SummaryTextSection>
          <SummaryText fontWeight={500}>
            {getHoursWithSeconds(toHHMMSS(summaryData.duration))}
          </SummaryText>
          <SummaryLabel>Total Time Worked</SummaryLabel>
        </SummaryTextSection>
        <SummaryTextSection>
          <SummaryText total>
            {summaryData.currency} ({currencySymbolMap[summaryData.currency]}){" "}
            {(summaryData.totalPay / 100).toFixed(2)}
          </SummaryText>
          <SummaryLabel>Total Payment</SummaryLabel>
        </SummaryTextSection>
      </SummarySectionContainer>
      <SelectAllDateMemberSection columns="auto 1fr">
        <ColoredButton
          type="gray"
          padding="0 15px"
          onClick={() => toggleConfirmPaymentModal("all")}
        >
          Mark all as paid
        </ColoredButton>
        {/* <ColoredButton  disabled={!selectAllDatesMembers} padding="11px 17px">
            Send Payment
          </ColoredButton> */}
      </SelectAllDateMemberSection>
    </SummaryContainer>
  ) : null;
};
